import { useEffect, useState } from 'react';
import SynchronizationService from '../services/synchronizationService';

/** Cenários de orçamento da empresa (páginas de cenário do Planejamento), para os seletores do Gestão/Studio. */
export function useBudgetScenarios(syncId, { enabled = true } = {}) {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!syncId || !enabled) {
      setScenarios([]);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    SynchronizationService.getBudgetScenarios(syncId)
      .then((list) => { if (!cancelled) setScenarios(Array.isArray(list) ? list : []); })
      .catch(() => { if (!cancelled) setScenarios([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [syncId, enabled]);

  return { scenarios, loading };
}
